import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const eventApi = createApi({
    reducerPath: 'eventApi',
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_BASE_URL }),
    endpoints: builder => ({
        getAllEvent: builder.query({
            query: () => `/api/events`,
        }),
        getEventBySlug: builder.query({
            query: slug => `/api/events/${slug}`,
        }),
    }),
});

export const { useGetAllEventQuery, useGetEventBySlugQuery } = eventApi;
